import { GameErrorType } from '@/features/Popup/types';
import React from 'react';
import useEventManagerEmitter from '@/event-manager/use-event-manager-emiter';
import { GAME_WINDOW_TO_CLIENT_EVENTS } from '@/event-manager/types';

type FreeSpinButtonsProps = {
  errorType?: GameErrorType;
  errorParameters?: string[];
  onClose?: () => void;
};

export const FreeSpinButtons: React.FC<FreeSpinButtonsProps> = ({
  errorType,
  errorParameters,
  onClose,
}) => {
  const { emitClientEvent } = useEventManagerEmitter();

  if (errorType !== 'free_spin_dialog_choose' || !errorParameters?.length) {
    return null;
  }

  return (
    <>
      {[...errorParameters]?.reverse().map((buttonText: string, index) => (
        <button
          key={index}
          className="popup__button popup__button--main"
          onClick={() => {
            emitClientEvent(
              GAME_WINDOW_TO_CLIENT_EVENTS.FREE_SPINS_DIALOG,
              errorParameters.length - 1 - index,
            );
            onClose?.();
          }}
          type="button"
        >
          {buttonText}
        </button>
      ))}
    </>
  );
};
